// Board, committee and "what sets us apart" content for the investor
// relations page. Extracted from InvestorTabs so lib/pageContentFields can
// derive the admin field list from the same arrays the page renders — the two
// used to be counted by hand, which drifts the moment a director or committee
// member is added.
//
// Positional CMS keys are generated from these arrays (board.N.*,
// committee.N.mN.*, apart.N.*): appending is safe, reordering shifts saved
// overrides.

// Board of Directors — from the Director Profiles deck.
export const directors: { name: string; role: string; exp: string; bio: string; photo: string }[] = [
  { name: "Karan Chopra", role: "Chairman, Whole Time Director & Co-CEO", exp: "18+ years", photo: "/images/leadership/karan-chopra.webp", bio: "Co-founder, PurpleYo Technologies. Co-founded and led multiple startups across real estate, media and entertainment. 'Young Achiever of the Year', Economic Times Realty Awards 2025." },
  { name: "Kunal Mehra", role: "President, Whole Time Director & Co-CEO", exp: "19+ years", photo: "/images/leadership/kunal-mehra.webp", bio: "Chairperson of the CSR Committee. Former Director, JLL Office Leasing Advisory; ex-Partner, Liquid Krystal Real Estate; ex-Manager, Taj Hotels, Resorts and Palaces." },
  { name: "Joseph Gagnon", role: "Non-executive Nominee Director", exp: "26+ years", photo: "/images/ir/board/joseph-gagnon.webp", bio: "Co-founder, Rava Partners (Real Assets strategy of Hillhouse Capital). Ex-MD, Warburg Pincus Asia Real Estate; ex-Manager, General Electric Capital." },
  { name: "Siddhartha Gupta", role: "Non-executive Nominee Director", exp: "19+ years", photo: "/images/ir/board/siddhartha-gupta.webp", bio: "Founder and Managing Partner at Alta Capital. Ex-MD, Blackstone; ex-VP, Merrill Lynch (Real Estate Asia fund investment team)." },
  { name: "Nilesh Vikamsey", role: "Independent Director", exp: "38+ years", photo: "/images/ir/board/nilesh-vikamsey.webp", bio: "Chairperson of the Audit Committee. Senior Partner at KKC & Associates LLP; currently on the boards of PNB Housing Finance, Gati and others." },
  { name: "Ganesh Natarajan", role: "Independent Director", exp: "26+ years", photo: "/images/ir/board/ganesh-natarajan.webp", bio: "Chairperson of the Stakeholder Relationship Committee. Ex-CEO of Aptech; previously on the boards of SBI, Fino Payments, RPG Enterprises and others." },
  { name: "Mukeeta Jhaveri", role: "Independent Director", exp: "39+ years", photo: "/images/ir/board/mukeeta-jhaveri.webp", bio: "Previously with Bank of America Merrill Lynch. Chairperson of the Board of UTI Trustee Company Private Limited; Independent Director at Raymond." },
  { name: "Anthony Couse", role: "Independent Director", exp: "38+ years", photo: "/images/ir/board/anthony-couse.webp", bio: "Chairperson of the Nomination and Remuneration Committee. Ex-CEO Asia Pacific, JLL; ex-Head of Commercial (London), De Groot Collis." },
];

// "What sets Table Space apart" — card grid at the end of Company Overview.
export const apart = [
  { title: "Enterprise-first", body: "Grade-A managed offices designed around how large teams actually work — built to hold and scale space with certainty." },
  { title: "National footprint", body: "A presence across India's key micro-markets, with centres in eight cities and counting." },
  { title: "End-to-end delivery", body: "From design-build (DESYN) to fit-out, operations and enterprise services — one accountable partner." },
  { title: "GCC enablement", body: "Global Connect helps global enterprises stand up and scale their India Global Capability Centres." },
  { title: "Trusted at scale", body: "Hundreds of enterprise clients, including global banks and category-defining technology firms." },
  { title: "Backed for growth", body: "Strategic capital from marquee investors fuels a disciplined, enterprise-focused expansion." },
];

// Committee composition — from the "Committee Positions" register.
export type CommitteeMember = { name: string; position: string; designation: string };
export const committees: { name: string; members: CommitteeMember[] }[] = [
  {
    name: "Audit Committee",
    members: [
      { name: "Mr. Nilesh Shivji Vikamsey", position: "Chairperson", designation: "Independent Director" },
      { name: "Mr. Anthony Charles Philip Couse", position: "Member", designation: "Independent Director" },
      { name: "Mr. Ganesh Natarajan", position: "Member", designation: "Independent Director" },
      { name: "Mr. Siddhartha Gupta", position: "Member", designation: "Non-Executive Nominee Director" },
    ],
  },
  {
    name: "Stakeholders Relationship Committee",
    members: [
      { name: "Mr. Ganesh Natarajan", position: "Chairperson", designation: "Independent Director" },
      { name: "Mr. Nilesh Shivji Vikamsey", position: "Member", designation: "Independent Director" },
      { name: "Mr. Kunal Mehra", position: "Member", designation: "Executive Director" },
    ],
  },
  {
    name: "Nomination and Remuneration Committee",
    members: [
      { name: "Mr. Anthony Charles Philip Couse", position: "Chairperson", designation: "Independent Director" },
      { name: "Mr. Nilesh Shivji Vikamsey", position: "Member", designation: "Independent Director" },
      { name: "Mr. Siddhartha Gupta", position: "Member", designation: "Non-Executive Nominee Director" },
      { name: "Mrs. Mukeeta Pramit Jhaveri", position: "Member", designation: "Independent Director" },
    ],
  },
  {
    name: "Risk Management Committee",
    members: [
      { name: "Mr. Karan Chopra", position: "Chairperson", designation: "Whole Time Director & Co-CEO" },
      { name: "Mr. Anthony Charles Philip Couse", position: "Member", designation: "Independent Director" },
      { name: "Mr. Nilesh Shivji Vikamsey", position: "Member", designation: "Independent Director" },
      { name: "Mr. Bittu Varghese", position: "Member", designation: "Chief Financial Officer" },
    ],
  },
  {
    name: "Corporate Social Responsibility Committee",
    members: [
      { name: "Mr. Kunal Mehra", position: "Chairperson", designation: "Executive Director" },
      { name: "Mr. Anthony Charles Philip Couse", position: "Member", designation: "Independent Director" },
      { name: "Ms. Mukeeta Pramit Jhaveri", position: "Member", designation: "Independent Director" },
    ],
  },
];
